module.exports={
	"Scope": "RolePermission-List",
	"CoreEntity": "RolePermission",
	"TitleTemplate": "Role Permissions",
	"Descriptors":
	{
		"Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermListHash",
			"PictDashboard": {}
		},
		"Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermListAllowed",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermListIDRole",
			"PictDashboard": {}
		},
		"Context":
		{
			"Name": "Context",
			"Hash": "RolePermListContext",
			"PictDashboard": {}
		}
	}
}
